import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import "../../resources/css/common.css";
import "../../resources/css/layout.css";
import ScrollAnimation from "../../resources/js/ScrollAnimation.js";
import Header from "../Header/Header.jsx";
import Footer from "../Footer/Footer.jsx";

const Location = () => {
  const location = useLocation();

  useEffect(() => {
    const titleElement = document.getElementsByTagName("title")[0];
    titleElement.innerHTML = `아소비 | 오시는 길`;

    // 페이지 뷰 추적
    window.gtag("config", "G-LYT78YCDYK", {
      page_path: location.pathname,
    });
  }, [location]);

  return (
    <div>
      <Header>
        <div className="header-down">
          <div className="wrap">
            <ul>
              <li>
                <a href="/company">아소비 철학</a>
              </li>
              <li>
                <a href="/history">주요 연혁</a>
              </li>
              <li>
                <a href="/location" className="sel">
                  오시는길
                </a>
              </li>
            </ul>
          </div>
        </div>
      </Header>
      <ScrollAnimation />
      <section id="container">
        <div className="subvisual">
          <div className="title">아소비 오시는 길</div>
          <div className="text">
            (주)아소비교육은 여러분의 방문을 언제든 환영합니다.
          </div>
          <div className="image">
            <img src="../custom-resources/img/sub_location_bg.png" alt="" />
          </div>
        </div>
        <div className="location">
          <div className="wrap">
            <div className="title">
              <i></i>
              <p>아소비 위치</p>
            </div>
            <div className="map">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3161.6604468874352!2d126.90986361557334!3d37.58661263073531!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x357c985344114967%3A0xf233d062cec18620!2z7ISc7Jq47Yq567OE7IucIOydgO2Pieq1rCDspp3sgrDroZwgMzM3!5e0!3m2!1sko!2skr!4v1649236885493!5m2!1sko!2skr"
                width="600"
                height="450"
                style={{ border: 0 }} // React에서 스타일 객체로 작성
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Google Maps Location"
              ></iframe>
            </div>
            <div className="cont">
              <ul>
                <li>
                  <div className="box">
                    <div className="ico">
                      <i></i>
                    </div>
                    <div className="tit">소재지</div>
                    <div className="txt">
                      <p>서울시 은평구 증산로 337 아소비빌딩</p>
                      <p>대표번호 : 1688-1993</p>
                    </div>
                  </div>
                </li>
                <li>
                  <div className="box">
                    <div className="ico">
                      <i></i>
                    </div>
                    <div className="tit">지하철 이용시</div>
                    <div className="txt">
                      <p className="medium">
                        <em className="brown">6호선</em> 증산역 4번 출구
                      </p>
                      <p>나와서 직진 약 500m 이동</p>
                      <p>은희네해장국 바로 옆 아소비빌딩</p>
                    </div>
                  </div>
                </li>
                <li>
                  <div className="box">
                    <div className="ico">
                      <i></i>
                    </div>
                    <div className="tit">버스 이용시</div>
                    <div className="txt">
                      <p>
                        <em className="blue">간선버스</em> : 571, 753
                      </p>
                      <p>
                        <em className="green">지선버스</em> : 7021, 7611, 7730
                      </p>
                      <p>(연서중학교에서 하차)</p>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default Location;
